<template>
    <div class="back-to-game-footer-mobile d-flex justify-content-between">
        <div class="col-5 d-flex align-items-center">
            <div class="title pt-1">
                🚨<Translate translationKey="quests-dashboard.youreOnActiveMission"
                             fallback="You're on active Mission right now:" />🚨
            </div>
        </div>
        <div :class="{ 'show': isPlayButtonVisible }"
             class="play-btn d-flex align-items-center justify-content-center"
             @click.stop="getUserBackToGame">
            <i class="fa-solid fa-play d-block play-icon ml-1 mt-1" />
        </div>
        <div class="d-flex align-items-center justify-content-center">
            <div>
                <BackToGameFooterTime />
                <div class="prize">
                    {{ userStore.activeUserRoundData?.quest_round?.quest_mission?.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import { useAuthStore } from '@/js/store/auth/AuthStore';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useUserStore } from '@/js/store/quests/dashboard/UserStore';
    import { closeCurtains } from '../../../game/animations/closeCurtains';
    import { questsRoutes } from '@/js/constants/questsRoutes';
    import { useMobileFooterAnimation } from '../../composables/useMobileFooterAnimation';
    import BackToGameFooterTime from '@/js/quests/dashboard/components/back-to-game-footer/BackToGameFooterTime.vue';

    const authStore = useAuthStore();
    const modalStore = useModalStore();
    const userStore = useUserStore();

    const isPlayButtonVisible = ref(false);

    const getUserBackToGame = () => {
        if (authStore.user?.must_verify_email) {
            modalStore.toggleModal(ModalEnum.FORCE_EMAIL_VERIFICATION, true);
        } else {
            closeCurtains(userStore.activeUserRoundData?.quest_round?.content?.url || questsRoutes.MISSION_ROUTE);
        }
    };

    useMobileFooterAnimation(isPlayButtonVisible);
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/missions-partials/z-index" as missionsZIndex;
@use "@/sass/design-system/fonts" as fonts;
@use "@/sass/design-system/variables" as variables;
@use "@/js/quests/global/sass/mixins/animations" as animationsMixins;

$mobile-footer-height: 60px;
$back-to-game-footer-height: 40px;

.back-to-game-footer-mobile {
    position: fixed;
    z-index: missionsZIndex.$back-to-game-footer-z-index;
    bottom: $mobile-footer-height;
    left: 0;
    width: 100%;
    height: $back-to-game-footer-height;
    padding: 0 8px;
    border-top: 1px solid legacyVariables.$dark-theme-border;
    border-bottom: 1px solid legacyVariables.$dark-theme-border;
    background-color: variables.$brand950;

    .play-btn {
        position: absolute;
        top: 100px;
        left: 50%;
        width: 80px;
        height: 80px;
        border: 1px solid variables.$warning500;
        border-radius: 50%;
        background-color: variables.$warning500;
        box-shadow: 0 0 20px variables.$warning600, 0 0 30px variables.$warning600;
        color: variables.$warning900;
        cursor: pointer;
        transform: translateX(-50%) translateY(0);
        transition: top 0s ease-in-out, transform 0.5s ease-in-out;

        @include animationsMixins.glow-animation(2s, variables.$warning600);

        &.show {
            top: $back-to-game-footer-height - 15px !important;
            transform: translate(-50%, -50%);
        }

        .play-icon {
            font-size: 27px;
        }
    }

    .title {
        color: legacyVariables.$golden-yellow;
        font-family: fonts.$font-quicksand;
        font-size: 8px;
        text-align: center;
        text-transform: uppercase;
    }

    .prize {
        max-width: 131px;
        color: variables.$baseWhite;
        font-size: 8px;
        font-weight: 500;
        line-height: 1;
    }

    @media (max-width: 374px) {
        .play-btn {
            width: 4rem;
            height: 4rem;

            .play-icon {
                font-size: 24px;
            }
        }
        .prize {
            max-width: 7.4rem;
        }
    }
}
</style>
